import { Webhook } from 'lucide-react';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';

import WebhookLogDashboard from './WebhookLogDashboard';

const NAV_ITEMS = [{ to: '/admin/data/webhooks', icon: Webhook, label: 'Webhook Logs' }];

export default function DataPage() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-bark-900 dark:text-stone-100">Data</h1>
        <p className="text-sm text-stone-500 dark:text-stone-400 mt-1">
          Pipeline monitoring and data tools
        </p>
      </div>
      <div className="flex gap-6 items-start">
        <nav className="w-44 flex-shrink-0">
          <ul className="flex flex-col gap-0.5">
            {NAV_ITEMS.map(({ to, icon: Icon, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition ${
                      isActive
                        ? 'text-moss-600 dark:text-moss-400 bg-moss-50 dark:bg-moss-900/20 font-medium'
                        : 'text-stone-600 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28]'
                    }`
                  }
                >
                  <Icon size={14} />
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex-1 min-w-0">
          <Routes>
            <Route index element={<Navigate to="webhooks" replace />} />
            <Route path="webhooks" element={<WebhookLogDashboard />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
